export default "__VITE_ASSET__7rHZUqJa__"